import ActionType from '../actions/types';

const initialState = {
  eventsList: [],
  upcomingEventsList: [],
  filter: 'upcoming',
};

export default function(state = initialState, action) {

  const {type, eventsList, upcomingEventsList, filter} = action;

  switch (type) {
    case ActionType.SET_EVENTS:
      return {
        ...state,
        eventsList,
      };
    case ActionType.SET_UPCOMING_EVENTS:
      return {
        ...state,
        upcomingEventsList,
      };
    case ActionType.CHANGE_EVENT_FILTER:
      return {
        ...state,
        filter,
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/events.js